import { useEffect, useState } from "react";
import "./style.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../sidebar";
import Header from "../header";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import methodModel from "../../../methods/methods";
import { FaArrowUp } from "react-icons/fa";
import { SidebarItems } from "../../../utils/constants";
import { FiMenu, FiX } from "react-icons/fi";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const Layout = ({ children, classes = "" }) => {
  const WebDetails = useSelector((state) => state.logo);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const URLPath = window.location.pathname;

  const [isOpen, setIsOpen] = useState(false);
  const [showIcon, setShowIcon] = useState(false);

  const CurrentServer = true;

  // Toggle sidebar
  const toggle = () => setIsOpen(!isOpen);

  // Scroll to top
  const scrollToTop = () => {
    window.scroll({ top: 0, behavior: "smooth" });
  };

  // Scroll listener
  useEffect(() => {
    const handleScroll = () => {
      setShowIcon(document.documentElement.scrollTop > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  // Router redirect helper
  const router = () => {
    const route = localStorage.getItem("route");
    if (route) navigate(route);
  };

  return (
    <>
      <div component="layout">
        <div onClick={router} id="routerDiv"></div>


     <div className={`main-wrapper flex !w-full ${isOpen ? "main-active" : ""}`}>
        <Header />
        {/* Sidebar toggle button */}
        <button
          onClick={toggle}
          className="btntoggle absolute left-[263px] top-[17px] h-8 w-8 shrink-0 shadow-btn hover:shadow-none rounded-full !text-white bg-[#115B9D] z-[999] transition-[width] duration-300 transition-[width] duration-300 p-1"
        >
          {isOpen ? <IoIosArrowForward className="w-full h-full" /> : <IoIosArrowBack className="w-full h-full" />}
        </button>
          {/* Sidebar */}
          <div
            className={`main-sidebar ${isOpen ? "active-sidebar" : ""} bg-white transition-[width] duration-300 z-[99]`}
          >
            <div className="sidebar-brand px-3 text-left !bg-transparent !mb-0">
              <label className="editLogo w-full mx-auto">
                <img
                  src="/assets/img/logo.png"
                  className="logocls show-logo w-[80px] object-contain mx-auto"
                />
                <img src="/assets/img/logo.png" className="hide-logo" width="24" height="24" />
              </label>
            </div>

            {user?.supplier_id?.logo || user?.logo ? (
              <div className="flex flex-col items-center justify-center mt-2">
                <img
                  src={methodModel.userImg(user?.supplier_id?.logo || user?.logo || "")}
                  alt="photo"
                  className="object-contain h-16 mt-2"
                />
                <div className="text-center mt-2">
                  {user?.supplier_id?.companyName || user?.companyName}
                </div>
              </div>
            ) : null}

            <Sidebar />
          </div>

          {/* Main content */}
          <main className={`main transition-[width] duration-500 scrollbar ${isOpen ? "!w-[calc(100%_-_80px)]" : ""}`}>
            <div className="!bg-[#F5F8FC] !p-5 mt-[64px] layout-drops">
              {/* Pinned tabs */}
              {CurrentServer && user?.pinnedTabs?.length > 0 && (
                <div className="rounded-xl flex flex-wrap gap-2 p-4 mb-8 bg-white">
                  {user.pinnedTabs.map((item) => (
                    <div
                      key={item}
                      style={{ cursor: "pointer" }}
                      className="flex flex-wrap justify-start gap-4"
                      onClick={() =>
                        navigate(SidebarItems?.find((i) => i?.name === item)?.Link || "")
                      }
                    >
                      <div className="border-gray px-2 py-1 text-xs bg-gray-100 border rounded-full">
                        {typeof item === "string" ? item : ""}
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {children}
            </div>
          </main>
        </div>

        {/* Scroll to top button */}
        {(URLPath === "/sales" ||
          URLPath === "/dashboard" ||
          URLPath === "/review-dashboard" ||
          URLPath === "/product-dashboard" ||
          URLPath === "/customers" ||
          URLPath === "/marketing/google-analytics" ||
          URLPath === "/accounting/dashboard") && (
          <div
            className={`${
              showIcon ? "block" : "hidden"
            } z-[999] h-10 w-10 fixed bottom-16 right-16 cursor-pointer shadow-box border border-gray-300 bg-white flex items-center justify-center`}
          >
            <FaArrowUp onClick={scrollToTop} title="Back Top" className="w-5 h-5" />
          </div>
        )}
      </div>

      <ToastContainer position="top-right" />
    </>
  );
};

export default Layout;